import React from 'react';

import { Box } from '@mui/material';

export const TabsContainer = ({ children }) => {
  return (
    <Box
      sx={{
        '@media (max-width:1003px)': {
          width: '100%',
        },
      }}
    >
      {children}
    </Box>
  );
};

export default TabsContainer;
